import { IUserKeyModel, IUserPreferenceModel, IUserPreferenceRequest, UserPreferenceConstant } from '@libs/vc-core-lib';

export interface SearchTablePreferenceKeys {
    scrollStorageKey: string;
    /** Used when `persistLayoutToUserPreferences` is true. */
    columnsPreferenceKey?: string;
    /** Used when `persistLayoutToUserPreferences` is true. */
    tablePreferenceKey?: string;
    /** Used when `persistLayoutToUserPreferences` is true. */
    pageRequestPreferenceKey?: string;
    filtersSessionStorageKey?: string;
    /**
     * User-preference category for layout keys. Defaults to `CATEGORY_UI_ASSESSMENT`.
     * Ignored when `persistLayoutToUserPreferences` is false.
     */
    preferenceCategory?: string;
}

export function saveFiltersToSession(storageKey: string | undefined, filters: unknown): void {
    if (!storageKey) {
        return;
    }
    sessionStorage.setItem(storageKey, JSON.stringify(filters));
}

/** Reads persisted search filters from sessionStorage; returns null when missing or invalid. */
export function readFiltersFromSession<T>(storageKey: string | undefined): T | null {
    if (!storageKey) {
        return null;
    }
    const raw = sessionStorage.getItem(storageKey);
    if (raw == null || raw === '') {
        return null;
    }
    try {
        return JSON.parse(raw) as T;
    } catch {
        return null;
    }
}

/** Clears a sessionStorage entry (e.g. scroll position before ViewChild is available). */
export function clearSessionStorageEntry(storageKey: string | undefined): void {
    if (!storageKey) {
        return;
    }
    sessionStorage.removeItem(storageKey);
}

export function buildUserPreferenceRequest(
    subCategory: string,
    attributeKey: string,
    category: string = UserPreferenceConstant.CATEGORY_UI_ASSESSMENT
): IUserPreferenceRequest {
    return {
        category,
        subcategory: subCategory,
        attributeKey,
    };
}

export function buildLayoutUserPreferenceModel(
    userKey: IUserKeyModel,
    attributeKey: string,
    value: unknown,
    subCategory: string = UserPreferenceConstant.SUBCATEGORY_LAYOUT,
    category: string = UserPreferenceConstant.CATEGORY_UI_ASSESSMENT
): IUserPreferenceModel {
    return {
        userKey,
        category,
        subCategory,
        attributeKey,
        attributeValue: JSON.stringify(value),
    };
}
